import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSuccessNotification } from 'services/common';
import { setIpPool } from 'services/domain';

// eslint-disable-next-line import/prefer-default-export
export const useSetIpPoolMapping = ({ successMessage }) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ senderDomain, receiverProvider, esp, ipPool }) => {
      return setIpPool({
        senderDomain,
        receiverProvider,
        esp,
        ipPool,
      });
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['ip_pool_mappings']);
        showSuccessNotification(successMessage || 'Success');
      },
    },
  );
};
